import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/reDistrict/create', params),
	update                : (params) => requests.post('/reDistrict/update', params),
	delete                : (params) => requests.getWithParams('/reDistrict/delete', params),
	restore               : (params) => requests.getWithParams('/reDistrict/restore', params),
	getPaged              : (params) => requests.getWithParams('/reDistrict/getPaged', params),
	getPagedAudit         : (params) => requests.getWithParams('/reDistrict/getPagedAudit', params),
	getPagedAll           : (params) => requests.getWithParams('/reDistrict/getPagedAll', params),
	getList               : (params) => requests.getWithParams('/reDistrict/getList', params),
	getListActualByRegion : (params) => requests.getWithParams('/reDistrict/getListActualByRegion', params)
}